import { useBudget } from '../store/BudgetContext';
import { useToast } from './Toast';
import { PlanPad } from './PlanPad';
import { ApiError, Category } from '../api/types';
import { fmtPlanNum } from '../utils/plan-pad';
import { planDailyLimit, planPerDay } from '../utils/plan-limit';

/** Инлайн-PlanPad с сохранением плана категории и тостом-гроссбухом. */
export function CategoryPlanPad(props: {
  category: Category;
  /** Все категории — для пересчёта лимита в тосте. */
  cats: Category[];
  onClose: () => void;
}): JSX.Element {
  const { category, cats, onClose } = props;
  const { updateCategory } = useBudget();
  const toast = useToast();

  function consequence(v: number): string {
    if (category.type === 'Доход') return 'ожидаемый доход';
    if (category.is_daily) return `≈${fmtPlanNum(planPerDay(v))} ₽/день`;
    return 'конверт месяца';
  }

  function handleDone(v: number) {
    onClose();
    if (v === category.plan_month) return;

    if (category.type === 'Расход' && category.is_daily) {
      const patchedCats = cats.map((c) =>
        c.id === category.id ? { ...c, plan_month: v } : c,
      );
      const newLimit = planDailyLimit(patchedCats);
      toast.reward({
        title: `${category.name} — план обновлён`,
        amount: `${fmtPlanNum(v)} ₽`,
        coin: false,
        sub: `дневной лимит теперь ≈${fmtPlanNum(newLimit)} ₽/день`,
      });
    } else {
      toast.reward({
        title: `${category.name} — план обновлён`,
        amount: `${fmtPlanNum(v)} ₽`,
        coin: false,
      });
    }

    updateCategory({ name: category.name, plan_month: v }).catch((e: unknown) => {
      if (e instanceof ApiError) {
        toast.show(e.message, 'error');
      } else {
        toast.show('Ошибка при сохранении', 'error');
      }
    });
  }

  return (
    <PlanPad
      initial={category.plan_month}
      consequence={consequence}
      onDone={handleDone}
    />
  );
}
